import DrawerLayout from "@/Shared/DrawerLayout";
import {mapActions} from 'pinia';
import {DataGatheringsStore} from "@/Store/DataGatherings/DataGatheringsStore";
import DataGatheringCardList from "@/Shared/DathaGatherings/Common/DataGatheringCardList";

export default {
    components: {DataGatheringCardList, DrawerLayout},

    props: {
        dataGatherings: {
            type: Array,
            default: [],
        },
        types: {
            type: Array,
            default: [],
        },
        academicPeriods: {
            type: Array,
            default: [],
        },
    },

    data() {
        return {

        };
    },

    methods: {
        ...mapActions(DataGatheringsStore, [
            'setAcademicPeriods',
            'setTypes',
            'setDataGatherings',
            'setCommonRoute',
        ]),
    },

    computed: {

    },

    mounted() {
        this.setAcademicPeriods(this.academicPeriods);
        this.setTypes(this.types);
        this.setDataGatherings(this.dataGatherings);
    },
};
